module.exports = "/assets/5cb67c661b7fef0c950510562323ae75.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/ET.png
// module id = 2474
// module chunks = 0